var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "comments-section" },
    [
      _c("comment-input", {
        on: { submit: _vm.submitComment, cancel: _vm.cancelComment },
        model: {
          value: _vm.newComment,
          callback: function($$v) {
            _vm.newComment = $$v
          },
          expression: "newComment"
        }
      }),
      _vm._v(" "),
      _vm._l(_vm.comments, function(c) {
        return _c("div", { key: c.id, staticClass: "comment" }, [
          _c(
            "div",
            { staticClass: "content" },
            [
              _c("div", { staticClass: "meta" }, [
                _c("span", { staticClass: "name" }, [
                  _vm._v("@" + _vm._s(c.sellerId))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "time" }, [
                  _vm._v(_vm._s(_vm.formatDate(c.createDate)))
                ])
              ]),
              _vm._v(" "),
              _vm.editingCommentId !== c.id
                ? _c("div", {
                    staticClass: "text",
                    domProps: {
                      innerHTML: _vm._s(_vm.convertTimestampsToLinks(c.content))
                    },
                    on: { click: _vm.onClickTimestamp }
                  })
                : _c("comment-input", {
                    attrs: {
                      placeholder: "コメントを編集...",
                      submitText: "保存",
                      autoFocus: true
                    },
                    on: {
                      submit: function($event) {
                        _vm.updateComment(c)
                      },
                      cancel: _vm.cancelEdit
                    },
                    model: {
                      value: _vm.editingContent,
                      callback: function($$v) {
                        _vm.editingContent = $$v
                      },
                      expression: "editingContent"
                    }
                  }),
              _vm._v(" "),
              _vm.editingCommentId !== c.id
                ? _c(
                    "div",
                    { staticClass: "actions" },
                    [
                      _c("like-button", {
                        attrs: { item: c },
                        on: {
                          handleClickLike: function($event) {
                            _vm.$emit("handleLikeComment", c)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          class: { "text-primary": c.isShowReplies },
                          attrs: { title: "返信" },
                          on: {
                            click: function($event) {
                              _vm.handleClickShowReplies(c)
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-reply-all",
                            attrs: { "aria-hidden": "true" }
                          }),
                          _vm._v(
                            "\n          " +
                              _vm._s(c.replies.length) +
                              "\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.sellerId === c.sellerId
                        ? _c(
                            "button",
                            {
                              attrs: { title: "編集" },
                              on: {
                                click: function($event) {
                                  _vm.handleClickEditComment(c)
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-pencil-square-o",
                                attrs: { "aria-hidden": "true" }
                              })
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(c.replies, function(r) {
                return c.isShowReplies
                  ? _c("div", { key: r.id, staticClass: "comment" }, [
                      _c(
                        "div",
                        { staticClass: "content" },
                        [
                          _c("div", { staticClass: "meta" }, [
                            _c("span", { staticClass: "name" }, [
                              _vm._v("@" + _vm._s(r.sellerId))
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "time" }, [
                              _vm._v(_vm._s(_vm.formatDate(r.createDate)))
                            ])
                          ]),
                          _vm._v(" "),
                          _vm.editingCommentId !== r.id
                            ? _c("div", { staticClass: "text" }, [
                                _vm._v(_vm._s(r.content))
                              ])
                            : _c("comment-input", {
                                attrs: {
                                  placeholder: "コメントを編集...",
                                  submitText: "保存",
                                  autoFocus: true
                                },
                                on: {
                                  submit: function($event) {
                                    _vm.updateComment(r)
                                  },
                                  cancel: _vm.cancelEdit
                                },
                                model: {
                                  value: _vm.editingContent,
                                  callback: function($$v) {
                                    _vm.editingContent = $$v
                                  },
                                  expression: "editingContent"
                                }
                              }),
                          _vm._v(" "),
                          _vm.editingCommentId !== r.id
                            ? _c(
                                "div",
                                { staticClass: "actions" },
                                [
                                  _c("like-button", {
                                    attrs: { item: r },
                                    on: {
                                      handleClickLike: function($event) {
                                        _vm.$emit("handleLikeComment", r)
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.sellerId === r.sellerId
                                    ? _c(
                                        "button",
                                        {
                                          attrs: { title: "編集" },
                                          on: {
                                            click: function($event) {
                                              _vm.handleClickEditComment(r)
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fa fa-pencil-square-o",
                                            attrs: { "aria-hidden": "true" }
                                          })
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm.replyInputs[c.id] !== undefined && !_vm.editingCommentId
                ? _c("comment-input", {
                    attrs: {
                      placeholder: "返信を追加...",
                      submitText: "返信",
                      autoFocus: true
                    },
                    on: {
                      submit: function($event) {
                        _vm.submitReply(c)
                      },
                      cancel: function($event) {
                        _vm.cancelReply(c)
                      }
                    },
                    model: {
                      value: _vm.replyInputs[c.id],
                      callback: function($$v) {
                        _vm.$set(_vm.replyInputs, c.id, $$v)
                      },
                      expression: "replyInputs[c.id]"
                    }
                  })
                : _vm._e()
            ],
            2
          )
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e64c2caa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e64c2caa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/video/components/VideoComments.vue
// module id = null
// module chunks = 